<template>
  <div v-if="policyDetails" class="mx-32 mb-72 flex justify-center">
    <!-- Only on desktop -->
    <div class="hidden space-y-32 md:block">
      <div
        v-if="displaySubmitClaim"
        class="bg-surface-default-low rounded-lg space-y-16 overflow-hidden p-32"
      >
        <div class="heading-3">
          {{ i18n(translations.submitClaimSectionTitle) }}
        </div>
        <SubmitClaim
          :partner-name="policyDetails.policy.offer.partnerName"
          :policy-state="policyDetails.policy.state"
        />
      </div>

      <div
        class="bg-surface-default-low rounded-lg space-y-16 overflow-hidden p-32"
      >
        <div class="heading-3">
          {{ i18n(translations.helpSectionTitle) }}
        </div>
        <HelpAndCancelButtons
          :partner-name="policyDetails.policy.offer.partnerName"
          :policy-start-date="policyDetails.policy.startDate"
          :policy-state="policyDetails.policy.state"
          :within-withdrawal-period="
            policyDetails.policy.withinWithdrawalPeriod
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAsyncData, useRouteParams } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './PolicyDetails.translations'
import HelpAndCancelButtons from './components/HelpAndCancelButtons/HelpAndCancelButtons.vue'
import SubmitClaim from './components/SubmitClaim/SubmitClaim.vue'

const { policyId } = useRouteParams()
const $httpFetch = useHttpFetch()
const i18n = useI18n()

const { data: policyDetails } = await useAsyncData(() =>
  $httpFetch('/api/insurance/v1/services-hub/policies/:policyId', {
    method: 'GET',
    pathParams: { policyId },
  }),
)

const displaySubmitClaim = computed(() => {
  return (
    policyDetails.value?.policy.state === 'ACTIVE' ||
    policyDetails.value?.policy.state === 'ON_HOLD'
  )
})
</script>
